module.exports = __webpack_public_path__ + "img/83.disposable_dishes.e9f92da9.svg";